// extracted by mini-css-extract-plugin
export default {"block":"Link_block__IJ5ur","title":"Link_title__cAk3P","text":"Link_text__XvQrS","textInvalid":"Link_textInvalid__c-dgg"};